module.exports = __webpack_public_path__ + "img/group23-ja.b73c67f3.png";